import { ReactNode, useEffect, useState } from 'react'

/**
 * Starts MSW in the browser when NEXT_PUBLIC_API_MOCKING=enabled,
 * and defers children until the worker is ready (avoids race with early API calls).
 */
const BrowserApiMockProvider = ({ children }: { children: ReactNode }) => {
  const shouldMock = process.env.NEXT_PUBLIC_API_MOCKING === 'enabled'
  const [isReady, setIsReady] = useState(!shouldMock)

  useEffect(() => {
    if (!shouldMock) {
      return
    }

    let cancelled = false

    void import('./browser')
      .then(({ enableBrowserMocking }) => enableBrowserMocking())
      .catch((error) => {
        console.error('[MSW] Failed to start browser mocking', error)
      })
      .finally(() => {
        if (!cancelled) {
          setIsReady(true)
        }
      })

    return () => {
      cancelled = true
    }
  }, [shouldMock])

  if (!isReady) {
    return null
  }

  return <>{children}</>
}

export default BrowserApiMockProvider
